export default "__VITE_ASSET__BOj3WQFJ__"